document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const cameFromSelectorTool = urlParams.has('attribute_loft') || 
                               urlParams.has('attribute_shaft') || 
                               urlParams.has('attribute_flex') || 
                               urlParams.has('attribute_length') || 
                               urlParams.has('attribute_grip') || 
                               urlParams.has('attribute_grip_size') || 
                               urlParams.has('attribute_hand');

  if (cameFromSelectorTool) return;

  function wait(selector, callBack) {
    const interval = setInterval(() => {
      const element = document.querySelector(selector);
      if (element) {
        setTimeout(callBack, 200);
        clearInterval(interval);
      }
    }, 300);
    setTimeout(() => {
      clearInterval(interval);
    }, 10000);
  }

  wait('select', () => {
    setPlease();
  });

  function setPlease() {
    const selectTags = document.querySelectorAll('select');
    if (!selectTags.length) {
      enableSubmitButton(); // Enable button if there are no dropdowns
      return;
    }

    selectTags.forEach((selectTag) => {
      selectTag.selectedIndex = 0;
      selectTag.style.color = "#717d96";

      selectTag.addEventListener("change", function () {
        this.style.color = this.selectedIndex === 0 ? "#717d96" : "#000000";
      });
    });

    watchSelectors();
  }

  function watchSelectors() {
    const driverSelectors = [
      '[id="loft"]',
      '[id="shaft-flex"]',
      '[id="shaft-type"]',
      '[id="shaft-length"]',
      '[id="grip-size"]'
    ];

    const otherSelectors = [
      '[id="shaft---flex"]',
      '[id="shaft---length"]',
      '[id="grip---size"]',
      '[id="flex"]',
      '[id="size"]',
      '[id="color"]'
    ];

    const adapterSelectors = [
      '[id="right-or-left-hand"]'
    ];

    const submitButtons = document.querySelectorAll('.product-form__submit[type="submit"]');

    if (!document.querySelectorAll(driverSelectors.join(', ') + ',' + otherSelectors.join(', ') + ',' + adapterSelectors.join(', ')).length) {
      enableSubmitButton(); // Enable button if no dropdowns exist
      return;
    }

    submitButtons.forEach((btn) => {
      btn.disabled = true;
    });

    const validate = (selectors) => {
      let count = 0;
      const dropdowns = document.querySelectorAll(selectors.join(', '));
      dropdowns.forEach((select) => {
        if (select.value !== "") {
          count++;
        }
      });

      if (dropdowns.length === count) {
        enableSubmitButton();
      } else {
        disableSubmitButton();
      }
    };

    document.addEventListener("change", (e) => {
      if (e.target.matches(driverSelectors.join(', '))) {
        validate(driverSelectors);
      }
      if (e.target.matches(otherSelectors.join(', '))) {
        validate(otherSelectors);
      }
      if (e.target.matches(adapterSelectors.join(', '))) {
        validate(adapterSelectors);
      }
    });
  }

  function enableSubmitButton() {
    document.querySelectorAll('.product-form__submit[type="submit"]').forEach((btn) => {
      btn.disabled = false;
    });
  }

  function disableSubmitButton() {
    document.querySelectorAll('.product-form__submit[type="submit"]').forEach((btn) => {
      btn.disabled = true;
    });
  }
});
